export default "__VITE_ASSET__B2OHp_FU__"